// Hi my name is {{name}} and I am {{age}} years old
export default (s: string, replacers: Record<string, string | number>) => {
    return Object.entries(replacers).reduce((acc, [k, v]) => {
        return acc.replace(`{{${k}}}`, v.toString())
    }, s)
}
